export enum ClinicalTypeEnum {
  RN = 1,
  LPN = 2,
  PT = 3,
  PTA = 4,
  ST = 5,
  OT = 6,
  COTA = 7,
  HHA = 8,
  MSW = 9
}

export const ClinicalTypeOptions = [
{ id: 1, label: 'Registered Nurse (RN)', abbreviation: 'RN', discipline: 'Skilled Nursing' },
{ id: 2, label: 'Licensed Practical Nurse (LPN)', abbreviation: 'LPN', discipline: 'Skilled Nursing' },
{ id: 3, label: 'Physical Therapist (PT)', abbreviation: 'PT', discipline: 'Physical Therapy' },
{ id: 4, label: 'Physical Therapist Assistant (PTA)', abbreviation: 'PTA', discipline: 'Physical Therapy' },
{ id: 5, label: 'Speech Therapist (ST)', abbreviation: 'ST', discipline: 'Speech Therapy' },
{ id: 6, label: 'Occupational Therapist (OT)', abbreviation: 'OT', discipline: 'Occupational Therapy' },
{ id: 7, label: 'Certified Occupational Therapist Assistant (COTA)', abbreviation: 'COTA', discipline: 'Occupational Therapy' },
{ id: 8, label: 'Home Health Aide (HHA)', abbreviation: 'HHA', discipline: 'Home Health Aide' },
{ id: 9, label: 'Medical Social Worker (MSW)', abbreviation: 'MSW', discipline: 'Medical Social Work' }
];
